import React from 'react';
import { getBrandConfig, BrandConfig } from "../brand-config";

export const BrandContext = React.createContext<BrandConfig>(getBrandConfig());